import React, { Component } from 'react'
import { VictoryChart, VictoryStack, VictoryBar, VictoryAxis, VictoryTooltip } from 'victory'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import riverIceDataTransform, { getDates } from '../utility/iceDataTransform'
import format from 'date-fns/format'
import { RIVER_CLASS_COLORS } from '../layers/paints'
import convertDateToUTC from '../utility/convertDateToUTC'

class Chart extends Component {
  onClick = (event, item) => {
    if (this.props.onClick) {
      this.props.onClick(item)
    }
  }

  render() {
    const { data, timestamp } = this.props
    if (!data || !timestamp) {
      return null
    }

    return (
      <>
        <VictoryChart height={400} width={400}
          domainPadding={{ x: 30, y: 20 }}
          scale={{ x: "time" }}
          events={[
            {
              target: "data",
              childName: data.map((item, i) => `bar-${i}`),
              eventHandlers: {
                onClick: this.onClick
              }
            }
          ]}
          style={{ data: { fill: 'red' } }}
          externalEventMutations={[
            {
              childName: data.map((item, i) => `bar-${i}`),
              target: ["data"],
              eventKey: "all",
              mutation: (item) => {
                const epoch = item.datum.timestamp ?
                      new Date(item.datum.timestamp).toISOString() :
                      new Date().toISOString()
                const epochSelected = new Date(timestamp).toISOString()

                const style = epoch === epochSelected
                  ? { fill: item.style && item.style.fill, stroke: "blue", strokeWidth: 1 }
                  : { ...item.style, stroke: "transparent" }
                return ({ style })
              }
            }
          ]}
        >
          <VictoryStack
            colorScale={RIVER_CLASS_COLORS}
          >
            {data.map((datum, i) => {
              return <VictoryBar
                name={`bar-${i}`}
                data={datum}
                key={i}
                       labels={(d) => d.area && `${(d.ratio * 100).toFixed(0)}%, ${d.area.toFixed(2)} km${String.fromCharCode(0x00B2)}`}
                labelComponent={<VictoryTooltip />}
                style={{
                  data: {
                    stroke: datum => {

                      const epoch = new Date(datum.timestamp).getTime()
                      const epochSelected = new Date(timestamp).getTime()

                      return epoch === epochSelected ? 'black' : 'transparent'
                    },
                    strokeWidth: 1
                  }
                }}

              />
            })}
          </VictoryStack>
          <VictoryAxis dependentAxis
            tickFormat={(tick) => `${tick}%`}
          />
          <VictoryAxis
            tickFormat={(x) => {
              const date = convertDateToUTC(new Date(x))

              return format(date, 'MMM d')
            }}
            fixLabelOverlap={true}
          />
        </VictoryChart>
      </>
    )
  }
}

export default Chart



// WEBPACK FOOTER //
// ./src/charts/RiverIceBreakupChart.js